import tokens from '@kluein/design-tokens';
import { Box, fontWeight, letterSpacing } from '@kluein/klue-ui';
import styled, { css } from 'styled-components';

import { APP_NAV_BAR_HEIGHT } from 'components/layout/app-nav-bar/constants';

const underlineStyle = css`
  content: '';
  position: absolute;
  width: 100%;
  height: 2px;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const StyledButton = styled(Box)<{ isActive?: boolean }>`
  button {
    align-items: center;
    display: flex;
    text-overflow: ellipsis;
    transition:
      background-color 250ms ease-in-out,
      color 250ms 125ms ease-in-out;
    white-space: nowrap;
    box-shadow: none;
    background-color: transparent;
    padding: 0;
    height: ${APP_NAV_BAR_HEIGHT};

    label {
      color: ${tokens.color.neutral.black.main};
      font-weight: ${fontWeight.bold};
      letter-spacing: ${letterSpacing.small};
      text-transform: uppercase;
    }

    &.active {
      box-shadow: none;
      background-color: transparent;
    }

    &:link,
    &:hover,
    &:visited,
    &:active {
      &,
      label {
        background-color: transparent;
        text-decoration: none;
        border-color: transparent;
        box-shadow: none;
      }
    }

    &:focus-visible {
      border: none;
      box-shadow: none;
      outline: none;
    }
  }

  ${({ isActive }) =>
    isActive &&
    css`
      &:after {
        ${underlineStyle}
        background-color: ${tokens.color.primitives.gray[900]};
      }
    `}

  &:hover:after {
    ${underlineStyle}
    background-color: ${tokens.color.primitives.gray[425]};
  }
`;

const isActiveStyle = css`
  background-color: ${tokens.color.neutral.lightgrey.main};
`;

export const StyledResponsiveBox = styled(Box)<{ isActive?: boolean }>`
  cursor: pointer;

  ${({ isActive }) => isActive && isActiveStyle}

  &:hover {
    ${isActiveStyle};
  }
`;
